import { BodyConverter } from '@iotize/tap/client/api';

import { TapStreamReader, TapStreamWriter } from '../../frame/tap-stream-core';

function safeParseInt(v: string) {
  const res = parseInt(v);
  if (isNaN(res)) {
    throw invalidStringVersionFormatError(v);
  }
  return res;
}

function invalidStringVersionFormatError(version: string) {
  return new Error(
    `Invalid string version format for "${version}". Should be x.x.x. For example: 1.0.3.`,
  );
}

export class StringVersionConverter implements BodyConverter<string> {
  public encode(
    version: string,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    const parts = version.split('.');
    if (parts.length !== 3) {
      throw invalidStringVersionFormatError(version);
    }
    stream.writeUnsigned(safeParseInt(parts[0]), 1);

    stream.writeUnsigned(safeParseInt(parts[1]), 1);

    stream.writeUnsigned(safeParseInt(parts[2]), 2);

    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): string {
    // if (!data || data.length !== 4) {
    //     throw ConverterError.unexpectedBufferSize(4, data);
    // }
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return `${stream.readUnsigned(1)}.${stream.readUnsigned(
      1,
    )}.${stream.readUnsigned(2)}`;
  }
}
